// extracted by mini-css-extract-plugin
export var resizer = "_gz-0";